(() => {
	document.addEventListener("DOMContentLoaded", () => {
		// const trustpilotScript = ["https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"];
		const frequentlyBoughtScript = ["https://cdn.codeblackbelt.com/scripts/frequently-bought-together/main.min.js?version=2024050715+0200"];
		// const volumeDiscountScript = ["https://d2e5xyzdl0rkli.cloudfront.net/shop/js/shopdocs-volume-discounts.min.js?shop=lebenskraft-pur.myshopify.com"];
		const hubSpotScript = ["https://js-eu1.hs-scripts.com/25429668.js"];
		// const klaviyoVendorScript = ["https://a.klaviyo.com/media/js/onsite/onsite.js"];
		// const klaviyoSettingsScript = [klaviyoSettingsScriptUrl];

		// let trustpilotScriptAdded = false;
		let frequentlyBoughtAdded = false;
		// let volumeDiscountAdded = false;
		let hubSpotAdded = false;
		let klaviyoAdded = false;

		const addScriptTagsToHeader = (scripts, callback) => {
			const scriptPromises = scripts.map((scriptPath) => {
				return new Promise((resolve, reject) => {
					const script = document.createElement("script");
					script.src = scriptPath;
					script.onload = resolve;
					script.onerror = reject;
					document.head.appendChild(script);
				});
			});

			Promise.all(scriptPromises)
				.then(callback)
				.catch((error) => console.error("Error loading script:", error));
		};

		// Trust Pilot
		// const addTrustpilotScripts = () => {
		// 	if (!trustpilotScriptAdded) {
		// 		addScriptTagsToHeader(trustpilotScript, () => {
		// 			trustpilotScriptAdded = true;
		// 		});
		// 	}
		// };

		// Frequently bought
		const addFrequentlyBoughtScripts = () => {
			if (!frequentlyBoughtAdded) {
				addScriptTagsToHeader(frequentlyBoughtScript, () => {
					frequentlyBoughtAdded = true;
				});
			}
		};

		// volume Discount
		// const addVolumeDiscountScripts = () => {
		// 	if (!volumeDiscountAdded) {
		// 		addScriptTagsToHeader(volumeDiscountScript, () => {
		// 			volumeDiscountAdded = true;
		// 		});
		// 	}
		// };

		// Trust Pilot
		const addHubspotScripts = () => {
			if (!hubSpotAdded) {
				addScriptTagsToHeader(hubSpotScript, () => {
					hubSpotAdded = true;
				});
			}
		};

		// Klaviyo
		// const addKlaviyoScripts = () => {
		// 	if (!klaviyoAdded) {
		// 		addScriptTagsToHeader(klaviyoVendorScript, () => {
		// 			addScriptTagsToHeader(klaviyoSettingsScript, () => {
		// 				klaviyoAdded = true;
		// 			});
		// 		});
		// 	}
		// };

		const addScriptsOnce = () => {
			// addKlaviyoScripts();
			//addTrustpilotScripts();
			addHubspotScripts();

			if (window.location.pathname.includes("products")) {
				addFrequentlyBoughtScripts();
				// addVolumeDiscountScripts();
			}

			window.removeEventListener("click", addScriptsOnce);
			window.removeEventListener("mousemove", addScriptsOnce);
			window.removeEventListener("scroll", addScriptsOnce);
			window.removeEventListener("touchstart", addScriptsOnce);
		};

		window.addEventListener("click", addScriptsOnce);
		window.addEventListener("mousemove", addScriptsOnce);
		window.addEventListener("scroll", addScriptsOnce);
		window.addEventListener("touchstart", addScriptsOnce);
	});
})();
